// extracted by mini-css-extract-plugin
export default {"totalProductCount":"VZbTh5SU1OsNkwSvy5FF"};